module.exports = __webpack_public_path__ + "static/media/chia_lin_lee.85ea376d.jpg";